import { APP_DATE_FORMAT_MID } from "@/config/constants";
import { IEdoCircular } from "@/shared/model/edo-circular.model";
import { IEdoFile } from "@/shared/model/edo-file.model";
import { getFileAvatar } from "@/shared/util/file-avatar-utils";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@/components/ui";
import { Download, Eye } from "lucide-react";
import "moment/locale/it";
import { TextFormat } from "react-jhipster";

interface ViewCircularProps {
  open: boolean;
  circular: IEdoCircular;
  onClose: () => void;
}

const ViewCircular = (props: ViewCircularProps) => {
  const { circular, open, onClose: handleClose } = props;

  const openFile = (file: IEdoFile) => {
    window.open(`/api/files/${file.id}/view`, "_blank");
  };

  const downloadFile = (file: IEdoFile) => {
    window.open(`/api/files/${file.id}/download`, "_blank");
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg">
        {!circular?.id ? (
          <div className="flex justify-center py-4">
            <span className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          </div>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>
                Circolare del{" "}
                <TextFormat
                  type="date"
                  value={circular.date}
                  format={APP_DATE_FORMAT_MID}
                  locale="it"
                />
              </DialogTitle>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <h3 className="text-heading font-semibold text-[var(--color-mockup-text)]">
                  {circular.title}
                </h3>
                <p className="text-body text-[var(--color-mockup-text-mid)] mt-1">
                  {circular.description}
                </p>
              </div>
              {circular.files?.length > 0 && (
                <div className="border-t border-[var(--color-mockup-border)] pt-4 dark:border-[var(--color-mockup-border)]">
                  <List className="divide-y">
                    {circular.files.map((file) => (
                      <ListItem
                        key={file.id}
                        className="flex items-center gap-3 py-2"
                      >
                        <ListItemIcon className="shrink-0">
                          {getFileAvatar(file.fileType)}
                        </ListItemIcon>
                        <ListItemText
                          primary={file.originalFileName}
                          className="min-w-0 flex-1 truncate"
                        />
                        <ListItemSecondaryAction className="ml-2 flex gap-0.5">
                          <IconButton
                            onClick={() => openFile(file)}
                            aria-label="Apri file"
                          >
                            <Eye className="h-4 w-4" />
                          </IconButton>
                          <IconButton
                            onClick={() => downloadFile(file)}
                            aria-label="Scarica file"
                          >
                            <Download className="h-4 w-4" />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </div>
              )}
            </div>
            <DialogFooter>
              <Button onClick={handleClose}>Chiudi</Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewCircular;
